import React, { useState } from 'react';
import { i18n } from "@translations/i18n";

import { WOWhiteLogo, WF_Logo_Color } from '@assets/index';
import { useTranslation } from 'react-i18next';
import { translate } from '@translations/Translater';
import { isPlatformLanguageArabic } from '@common/domain/models/User';
import LanguageDropdown from '@components/molecules/LanguageDropdown';
import { platform } from '@constants/config';
import { WFPrimaryButton } from '@components/index';
import { LanguageService } from "@webServices/LanguageService";
import { layoutMessages } from '@layout/messages';

import './styles.less';


const GuestHeader = () => {
    const [langCode, setLangCode] = useState(i18n.language);
    const { t } = useTranslation();
    const handleLanguage = (language) => {
        setLangCode(language);
        LanguageService.changeLanguage(language);
    }

    const onHelpBtnClick = () => {
        window.open(`https://wadhwani-foundation.freshdesk.com/${langCode}/support/home`);
    }

    return (
        <div className="guest-header">
            {platform.WO && <img alt="guest page WO logo" src={WOWhiteLogo} />}
            {platform.WITP && <img alt="WF logo color" src={WF_Logo_Color} width={100} height={50} />}
            {platform.WO && <div className={`help-btn ${isPlatformLanguageArabic() && 'ar-help-btn'}`}>
                <WFPrimaryButton 
                    className="help-cta" 
                    htmlType={"button"} 
                    onClick={onHelpBtnClick} 
                >
                    {translate(t, layoutMessages.help)}
                </WFPrimaryButton>
            </div>
            
            }
            {platform.WO && <div className={`app-language ${isPlatformLanguageArabic() && 'ar-app-language'}`}>
                <LanguageDropdown
                    onSelectLanguage={handleLanguage}
                    containerStyle="language-container"
                    labelClassName="language-label"
                    dropdownStyle="language-dropdown"
                    preferredLangCode={langCode}
                />
            </div>}
        </div>
    )
}

export default GuestHeader;
